import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'smr-circle-text-avatar',
  templateUrl: './circle-text-avatar.component.html',
  styleUrls: ['./circle-text-avatar.component.scss']
})
export class CircleTextAvatarComponent implements OnInit {
  private COLORS: any[] = [
    '#e57373',
    '#f06292',
    '#ba68c8',
    '#9575cd',
    '#7986cb',
    '#64b5f6',
    '#4fc3f7',
    '#4dd0e1',
    '#4db6ac',
    '#81c784',
    '#aed581',
    '#ff8a65',
    '#d4e157',
    '#673ab7',
    '#ffb74d',
    '#a1887f',
    '#90a4ae'
  ];

  @Input() firstName: string;

  @Input() lastName: string;

  public backGroundColor: string;

  constructor() {}

  public ngOnInit() {

    let index = 0;

    if (this.firstName && this.firstName.length >= 2) {
      index =
        (this.firstName.charCodeAt(0) +
          this.firstName.charCodeAt(this.firstName.length - 1)) %
        this.COLORS.length;
    } else {
      // get a random colour
      index = this.getRandomInt(0, this.COLORS.length - 1);
    }

    this.backGroundColor = this.COLORS[index];
  }

  /**
   * Returns a random integer between min (inclusive) and max (inclusive)
   * Using Math.round() will give you a non-uniform distribution!
   */
  private getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
